import { useMemo } from 'react';

export const ALL_YEARS = 'ALL' as const;
export type YearFilterValue = typeof ALL_YEARS | string;

export function useAllYearsFilters(
	source: { publicationDate: string }[],
): YearFilterValue[] {
	const allYearsFilters = useMemo(() => {
		const filters = [
			...new Set(
				source.map((item) =>
					new Date(item.publicationDate).getFullYear().toString(),
				),
			),
		].sort((a, b) => Number(b) - Number(a));

		// Add all years filter to top of list
		return [ALL_YEARS, ...filters];
	}, [source]);

	return allYearsFilters;
}
